<template>
  <v-container>
    <v-dialog
      v-model="show"
      persistent
      width="auto"
      max-width="60%"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card flat class="ma-0 pa-1">
        <v-card-title>
          マイ機器の登録
          <v-spacer></v-spacer>
          <v-icon @click="close()" class="my-3 mx-2">mdi-close-circle </v-icon>
        </v-card-title>
        <v-card-subtitle>
          新しいマイ機器情報を登録します。
        </v-card-subtitle>
        <v-card-text class="mb-5 pb-0">
          <v-stepper
            v-model="e6"
            vertical
            editable
            class="ma-0"
          >
            <v-stepper-step :complete="e6 > 1" step="1" editable color="teal darken-1" class="ma-0 pa-2">
              分析依頼の種類
            </v-stepper-step>
            <v-stepper-content step="1">
              <div class="caption mb-2">登録する機器で分析依頼する種類を選択して下さい。</div>
              <div class="caption mb-2">分析・診断サービスで依頼できる分析項目や報告書が変わります。</div>
              <v-btn
                color="amber"
                @click="selectAnalizeTypeGroup('一般')"
                class="my-3 mx-2"
                rounded
                x-large
               width="80%"
              >
                <v-icon class="mr-3" x-large>mdi-truck </v-icon>
                <v-icon class="mr-3" x-large>mdi-factory</v-icon>
                <div class="title font-weight-bold ml-2">一般</div>
                <div class="body-2">（航空機以外）</div>
                
              </v-btn>
              <div class="caption mb-2 ml-8">一般的な分析項目での分析診断、報告書を作成を希望する</div>
              <div class="caption mb-2 ml-8">航空機以外の自動車や機械などはこちらを選択してください</div>

              <v-btn
                color="amber"
                @click="selectAnalizeTypeGroup('航空機')"
                class="my-3 mx-2"
                rounded
                x-large
                width="80%"
              >
                <v-icon class="mr-2" x-large>mdi-airplane</v-icon>
                <v-icon class="mr-2" x-large>mdi-helicopter</v-icon>
                <div class="title font-weight-bold ml-2">航空機</div>
              </v-btn>
              <div class="caption mb-2 ml-8">航空機専用の分析項目での分析診断、報告書を作成を希望する</div>
              <div class="caption mb-2 ml-8">飛行機やヘリコプターなどの航空機はこちらを選択してください。</div>
<!--
                    <v-btn
                      text
                      min-height="20"
                      target="_blank"
                      class="x-small align-center"
                      @click="openAboutJET()"
                    >
                      <span class="text-left">こちら</span>
                    </v-btn>
-->
              <v-btn
                small
                text
                      @click="openAboutJET()"
                class="mt-0 pt-0 mb-2 ml-8 pl-0"
              >
                <v-icon color="primary" class="mr-1">mdi-information</v-icon>分析依頼の種類「航空機」についてはこちらをご確認ください。
              </v-btn>



            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" step="2" color="teal darken-1" class="ma-0 pa-2">
              登録する機器の種類
            </v-stepper-step>
            <v-stepper-content step="2" >
              <div class="title mt-0 pt-0 mb-2 font-weight-bold">分析依頼の種類：{{categoryText}}</div>
              <div class="caption mb-2">登録するマイ機器の種類を選択して下さい。</div>
              <v-btn
                color="amber"
                @click="selectMachineType('機体')"
                class="my-3 mx-2"
                rounded
                x-large
                :disabled="category == '一般'"
                width="80%"
              >
                <v-icon v-if="category=='航空機'" class="mr-2" x-large>mdi-airplane</v-icon>
                <v-icon v-if="category=='航空機'" class="mr-2" x-large>mdi-helicopter</v-icon>
                <v-icon v-if="category=='一般'"   class="mr-2" x-large>mdi-truck</v-icon>
                <v-icon v-if="category=='一般'"   class="mr-2" x-large>mdi-factory</v-icon>
                <div class="title font-weight-bold ml-2">機体</div>
              </v-btn>
              <div v-if="category=='一般'"   class="caption mb-2 ml-8">自動車や船舶、建物など、装備品が搭載／設置される機械や機体</div>
              <div v-if="category=='一般'"   class="caption mb-2 ml-8">機体を登録しておくことで「機体」と「装備品」を関連づけて管理することができます。</div>
              <div v-if="category=='航空機'" class="caption mb-2 ml-8">ジェット機やヘリコプターなど、装備品が搭載／設置される機体</div>
              <div v-if="category=='航空機'" class="caption mb-2 ml-8">AIRCRAFT TT、AIR CRAFT TSOなどは機体情報として管理します</div>
              <div class="caption mb-2 ml-8">ひとつの「機体」に複数の「装備品」を紐づけることもできます。</div>

              <v-btn
                color="amber"
                @click="selectMachineType('装備装置')"
                class="my-3 mx-2"
                rounded
                x-large
                width="80%"
              >
                <v-icon v-if="category=='航空機'" class="mr-2" x-large>mdi-engine </v-icon>
                <v-icon v-if="category=='航空機'" class="mr-2" x-large>mdi-cogs  </v-icon> 
                <v-icon v-if="category=='一般'"   class="mr-2" x-large>mdi-engine  </v-icon> 
                <v-icon v-if="category=='一般'"   class="mr-2" x-large>mdi-cogs  </v-icon> 
                <div class="title font-weight-bold ml-2">装備品</div>
                <div class="body-2">（オイル）</div>
              </v-btn>
              <div class="caption mb-2 ml-8">エンジンや変速機など分析診断対象のオイルを使用している装置や装備</div>
              <div class="caption mb-2 ml-8">「装備品」を登録しておくことで簡単に使用オイルの分析依頼をすることができます。</div>
              <div class="caption mb-2 ml-8">例）「ジェット機」の「エンジンのエンジンオイル」と「変速機の潤滑油」</div>
              <v-card flat outlined class="pa-2 mb-2 ml-8">
                <v-card-title class="caption pa-0">
                  <v-icon class="mr-1" color="primary">mdi-information-outline</v-icon>
                  <span class="primary--text">登録済みの「機体」に新しい「装備品」を追加登録する場合</span>
                </v-card-title>

                <v-card-text class="caption pb-0">
                  機体のマイ機器情報画面からも装備品を登録できます。<br>
                  機体に関連付けて装備品を登録できるので便利です。
                </v-card-text>
              </v-card>
              <div class="caption mb-2 ml-8">装備品と機体の関連付けは、マイ機器情報画面から行ないます。</div>
              <div class="caption mb-2 ml-8">登録済みの「装備品」を別の機体に関連付けなおすこともできます。</div>

            </v-stepper-content>
    
            <v-stepper-step :complete="e6 > 3" step="3" color="teal darken-1" class="ma-0 pa-2">
              登録する機器
            </v-stepper-step>
            <v-stepper-content step="3" >
              <div v-if="category=='航空機'" class="title mb-2 font-weight-bold">
                「{{categoryText}}」の「{{machineTypeText}}情報」を登録します。
              </div>
              <div v-if="category=='一般'" class="title mb-2 font-weight-bold">
                「{{categoryText}}」のマイ機器情報を登録します。
              </div>
              <v-btn
                rounded
                color="amber"
                @click="gotoMyMachine()"
                class="my-3 mx-2"
              >
                <v-icon>mdi-checkbox-marked-circle</v-icon>次へ
              </v-btn>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
        <v-card-actions class="my-0 py-0">
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-container>
</template>

<script>

export default {
  name: "componentname",
  head: {
    title: { inner: 'タイトル'},
  },
  data() {
    return {
      show: true,
      e6: 1,
      formTitle: "select A",
      category: "",
      categoryText: "",
      machineType: "",
      machineTypeText: "",
//      about_JET_url: process.env.VUE_APP_ABOUT_JET_URL,
      about_JET_url: "https://www.japan-analysts.com/oilmatrix/about_analizetype_JET.pdf"
		,
    };
  },
  filters: {
  },
  computed: {
  },
  mounted: async function () {
  },
  methods: {
    selectAnalizeTypeGroup: function(category) {
      switch (category){
        case "航空機":
          this.categoryText = "航空機"
          this.e6 = 2
          break
        default:
          this.categoryText = "一般（航空機以外）"
          this.machineTypeText = "装備品"
          this.machineType = "装備装置"
          this.e6 = 3
          break
      }
      this.category = category
      return
    },
    selectMachineType: function(machineType) {
      switch (machineType){
        case "機体":
          this.machineTypeText = "機体"
          break
        default:
          this.machineTypeText = "装備品"
          break
      }
      this.machineType = machineType
      this.e6 = 3
      return
    },
    gotoMyMachine: async function() {
      switch (this.machineType){
        case "機体":
          this.$router.push("/myaircraft?type=" + this.machineType + "&category=" + this.category)
          break
        default:
          this.$router.push("/mymachine?type=" + this.machineType + "&category=" + this.category)
          break
      }
      return true
    },
    close() {
      this.$router.back()
    },
    openAboutJET() {
      window.open(this.about_JET_url, '_blank')
    },
  }
};
</script>
